export default __webpack_public_path__ + "TG-wafl-SM-1000w.21d0c1b.png";